module.exports = __webpack_public_path__ + "img/search_currentCol.bcc7158f.svg";